import { ModalProps, Splitter } from "antd";
import { FC, ReactNode } from "react";
import { ModalWrap, SplitterWrap } from "./style";
import React from "react";
import LogHome from "./components/LogHome";

interface DetailModalProps {
  modalProps: ModalProps;
  children: ReactNode;
  docId?: string;
  logBookId?: string;
  noLog?: boolean;
}

const DetailModal: FC<DetailModalProps> = ({
  logBookId,
  modalProps,
  children,
  noLog = false,
}) => {
  // 这里是为了兼容 antd v5 的 Modal 组件样式问题，后续可以删除
  const mergedStyles: ModalProps["styles"] = {
    ...modalProps.styles,
    wrapper: {
      overflow: "inherit",
      ...modalProps.styles?.wrapper,
    },
  };

  return (
    <ModalWrap open centered footer={null} {...modalProps} styles={mergedStyles}>
      {
        noLog ? children
          : <SplitterWrap>
            <Splitter>
              <Splitter.Panel collapsible defaultSize="70%" min="20%" max="80%" className="ant-splitter-panel--wrap">
                {children}
              </Splitter.Panel>
              <Splitter.Panel collapsible defaultSize="30%" min="20%" max="80%">
                <LogHome logBookId={logBookId} />
              </Splitter.Panel>
            </Splitter>
          </SplitterWrap>
      }

    </ModalWrap>
  );
};

export default DetailModal;
